export default function isOuterArea(el, event) {
  var rect = el.getBoundingClientRect();
  return rect.left > event.clientX || rect.top > event.clientY || rect.right < event.clientX || rect.bottom < event.clientY;
}